import { HTTP } from "@/common/http-common";

const RESOURCE_NAME = "entities/lectureEvaluations";

export default {
  async getAllByEdition(id, options = {}) {
    const response = await HTTP.get(`${RESOURCE_NAME}/edition/${id}`, options);
    return response.data;
  },

  async getAllPending(options = {}) {
    const response = await HTTP.get(`${RESOURCE_NAME}/pending`, options);
    return response.data;
  },

  async updateState(entity) {
    return (
      await HTTP.put(`${RESOURCE_NAME}/${entity.id}/update-state`, entity)
    ).data;
  },

  async getAllByTeacherId(id, options = {}) {
    const response = await HTTP.get(`${RESOURCE_NAME}/teacher/${id}`, options);
    return response.data;
  },

  async save(entity) {
    if (entity.id) {
      return (await HTTP.put(`${RESOURCE_NAME}/${entity.id}`, entity)).data;
    } else {
      return (await HTTP.post(`${RESOURCE_NAME}`, entity)).data;
    }
  },
};
